import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import CoreServices from "./sections/CoreServices";
import AdditionalServices from "./sections/AdditionalServices";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <CoreServices />
      <AdditionalServices />
      <Footer />
    </div>;
}